import LegalPage from "./LegalPage";

const ICIP_SECTIONS = [
  {
    heading: "Recognition",
    body: [
      "Bigibila Consultancy / BIGIBILA SYSTEMS™ acknowledges the Traditional Custodians of the lands across Australia, and honours Elders past, present and emerging. We recognise that Aboriginal and Torres Strait Islander Cultural and Intellectual Property (ICIP) belongs to the communities, peoples and knowledge holders from whom it originates.",
      "We acknowledge that Indigenous governance has operated through sophisticated relational systems — kinship, language, Lore, marriage systems, responsibility, place, authority, obligation and accountability — for tens of thousands of years.",
    ],
  },
  {
    heading: "What ICIP includes",
    body: [
      "ICIP includes (but is not limited to): traditional knowledge, stories, songs, designs, language, kinship structures, place knowledge, ceremonial practice, plant and animal knowledge, and the cultural rights and responsibilities attached to all of these.",
    ],
  },
  {
    heading: "Our commitments",
    body: [
      "BIGIBILA SYSTEMS™ is not a database of culture. We do not centralise, extract, own or commercialise Aboriginal cultural knowledge.",
      "Custodianship of any cultural material remains at all times with the rightful Custodians and the community of origin. The platform supports authority, permission, protection, accountability and evidence — it does not replace cultural decision-making.",
      "Any engagement that involves cultural material requires Free, Prior and Informed Consent (FPIC) from the relevant Custodians and community. Consent is treated as time-bound, scoped and revocable.",
    ],
  },
  {
    heading: "How sensitive material is handled",
    body: [
      "Sensitive material is held under restricted access tiers and is gated by authority, purpose, conditions and recorded consent. It is not visible to non-custodians without an explicit consent receipt.",
      "If material is shared outside agreed conditions, the takedown and withdrawal process applies and an escalation is raised.",
    ],
  },
  {
    heading: "Working with us",
    body: [
      "If you intend to share or discuss sensitive cultural material with us, please contact us first. We will arrange an appropriate, custodian-respecting channel — not via this website's contact form.",
    ],
  },
];

export default function ICIPNotice() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="Cultural & ICIP Notice"
      lastUpdated="DRAFT — Feb 2026"
      sections={ICIP_SECTIONS}
    />
  );
}
